import React, { useEffect } from "react";
import { Ptag, LargeButton } from "components/core";
import { useNavigate } from "react-router-dom";
import { formatDateSequence, formatDecimalToCSV } from "utlis/utils";
import LinkIcon from "assets/svgs/link_arrow.svg";
import {
  ButtonWrapper,
  SummaryBox,
  BoxTop,
  TransactionDiv,
  Link,
  LinkImage,
  LinksWrapper,
} from "./style";

const InsurancePlan = (planType) => {
  switch (planType) {
    case "GMC":
      return "Group Health Insurance";
    case "GMC_M":
      return "Group Health Insurance";
    case "GPA":
      return "Group Personal Accident";
    case "GTL":
      return "Group Term Life";
  }
};

const CdbalanceCard = ({ tableData, planType }) => {
  const navigate = useNavigate();
  const navigateToUpdateBalance = () => {
    navigate("/v1/cash-deposit/update", {
      state: {
        keyPlanId: planType,
        planType: planType,
        originalData: tableData,
      },
    });
  };
  const handleChange = () => {
    navigate("/v1/cash-deposit/transactions", {
      state: { transactionData: tableData.transactions },
    });
  };
  const downloadFile = () => {
    const url = tableData.cd_balance_statement_url;
    window.open(url, true);
  };
  const getLastUpdatedDate = (tableDate) => {
    let updatedDateTransaction =
      (tableDate &&
        tableDate.transactions &&
        // tableDate.transactions.length() &&
        tableDate.transactions[0].transaction_date_show) ||
      "";
    let lastUpdated = (tableDate && tableDate.last_updated_date) || "";
    lastUpdated = lastUpdated || updatedDateTransaction || "";
    lastUpdated = formatDateSequence(lastUpdated.substring(0, 10));
    return lastUpdated;
  };
  const getUpdatedAmount = (tableDate) => {
    const amountTransaction =
      (tableDate &&
        tableData.transactions &&
        // tableDate.transactions.length() &&
        tableDate.transactions[0].updated_balance) ||
      0;
    const balanceAmount = tableDate && tableDate.balance_amount;
    const returnValue = balanceAmount || amountTransaction || 0;
    return formatDecimalToCSV(returnValue);
  };

  useEffect(() => {}, []);

  const lastUpdatedCd = () => {
    return (
      <div>
        <SummaryBox>
          <div>
          <BoxTop>
            <div style={{ width: "290px" }}>
              <div style={{ minHeight: "6rem" }}>
                <Ptag
                  fontSize="16px"
                  fontWeight="600"
                  letterSpacing="0.338333px"
                  letterHeight="24px"
                  fontFamily="Montserrat"
                >
                  {tableData.service_provider_name}
                </Ptag>
                {getLastUpdatedDate(tableData) && (
                  <Ptag
                    fontSize="12px"
                    fontWeight="400"
                    letterSpacing="0.6px"
                    letterHeight="16px"
                    fontFamily="Montserrat"
                  >
                    Last updated on{" "}
                    {getLastUpdatedDate(tableData).substring(0, 10) || "-"}
                  </Ptag>
                )}
              </div>
              <Ptag
                fontSize="24px"
                fontWeight="600"
                letterSpacing="0.6px"
                letterHeight="44px"
                marginTop="20px"
                fontFamily="Montserrat"
              >
                Rs. {getUpdatedAmount(tableData)}
              </Ptag>
            </div>
          </BoxTop>
          <LinksWrapper>
            {tableData && tableData.cd_balance_statement_url ? (
              <Link onClick={downloadFile}>
                <Ptag fontSize="12px" fontWeight="600" color="#4A90E2" fontFamily="Montserrat">
                  View Statement
                </Ptag>
                <LinkImage src={LinkIcon} />
              </Link>
            ) : (
              <span></span>
            )}
            {tableData && tableData.transactions && (
              <Link onClick={handleChange}>
                <Ptag fontSize="12px" fontWeight="600" color="#4A90E2" fontFamily="Montserrat">
                  View Transaction History
                </Ptag>
                <LinkImage src={LinkIcon} />
              </Link>
            )}
          </LinksWrapper>
          </div>
          <TransactionDiv>
            <ButtonWrapper>
              <LargeButton
                onClick={navigateToUpdateBalance}
                fontSize={"16px"}
                borderRadius={"10px"}
                width={"100px"}
                label={"Update Balance"}
                marginTop={"16px"}
                style={{ marginBottom: "12px" }}
              />
            </ButtonWrapper>
          </TransactionDiv>
        </SummaryBox>
      </div>
    );
  };

  return <>{lastUpdatedCd()}</>;
};
// }

export default CdbalanceCard;
